import React, { useState } from 'react';
import { colors, gradients, radii, shadows } from '../../theme/tokens';
import Icon from './Icon';

// Shared button. Variants: primary (green gradient pill), ghost, danger, subtle.
const Button = ({
  children,
  variant = 'primary',
  size = 'md', // sm | md | lg
  icon,
  iconRight,
  full = false,
  disabled = false,
  style,
  type = 'button',
  ...rest
}) => {
  const [hover, setHover] = useState(false);

  const sizes = {
    sm: { padding: '8px 14px', fontSize: 13 },
    md: { padding: '12px 22px', fontSize: 15 },
    lg: { padding: '15px 30px', fontSize: 17 }
  };

  const variants = {
    primary: {
      background: hover ? gradients.buttonHover : gradients.button,
      color: colors.white,
      border: 'none',
      boxShadow: hover ? shadows.glow : shadows.sm
    },
    ghost: {
      background: hover ? colors.glassStrong : colors.glass,
      color: colors.text,
      border: `1px solid ${colors.glassBorder}`
    },
    danger: {
      background: hover ? colors.redDeep : colors.red,
      color: colors.white,
      border: 'none'
    },
    subtle: {
      background: 'transparent',
      color: colors.textMuted,
      border: '1px solid transparent'
    }
  };

  return (
    <button
      type={type}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        borderRadius: radii.pill,
        fontWeight: 700,
        fontFamily: 'inherit',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        width: full ? '100%' : 'auto',
        transition: 'transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease',
        transform: hover && !disabled ? 'translateY(-1px)' : 'none',
        ...sizes[size],
        ...variants[variant],
        ...style
      }}
      {...rest}
    >
      {icon && <Icon name={icon} size={sizes[size].fontSize + 4} />}
      {children}
      {iconRight && <Icon name={iconRight} size={sizes[size].fontSize + 4} />}
    </button>
  );
};

export default Button;
